/**
 * Shared form style constants for Survey section forms.
 * Single source of truth — import from here instead of declaring locally.
 */

export const INPUT_CLASS =
  'w-full px-3.5 py-2.5 bg-slate-50 ring-1 ring-slate-200 rounded-xl text-sm font-semibold text-slate-900 focus:ring-2 focus:ring-[#3FA5FF] focus:bg-white outline-none transition-all';

export const LABEL_CLASS =
  'block text-[11px] font-black text-slate-600 uppercase tracking-wide mb-1.5';

export const TEXTAREA_CLASS = `${INPUT_CLASS} resize-none`;

export const TOGGLE_ACTIVE =
  'bg-[#3FA5FF]/10 ring-1 ring-[#3FA5FF]/30 text-[#007ACC] font-bold';

export const TOGGLE_INACTIVE = 'bg-slate-100 text-slate-500 hover:bg-slate-200 font-medium';
